export default __webpack_public_path__ + "static/media/chem.e5ffda4d.png";